import { FormGroup } from '@material-ui/core';
import { FormikProps } from 'formik';
import { FC } from 'react';
import useMasterStyles from '../../assets/styles/Master.css';
import useUikitStyles from '../../assets/styles/Uikit.css';
import {
  PrimaryReadOnlyField,
  UIError,
  UIReturn,
  UISubmit,
  UITextField,
} from '../index';

/**
 *
 *
 *
 * @method Interface
 * @version 1.0.0
 * -------------------------------------------------------------------------- */
interface FormValues {
  name: string;
  belongingName: string;
}
type Props = FormikProps<FormValues> & {
  email: string;
};
/**
 *
 *
 *
 * @method Components
 * @version 1.0.0
 * -------------------------------------------------------------------------- */
const Form: FC<Props> = (props) => {
  const { handleSubmit, handleChange, values, errors, email } = props;
  const masterClasses = useMasterStyles();
  const uikitClasses = useUikitStyles();

  return (
    <form onSubmit={handleSubmit} noValidate autoComplete="off">
      <p style={{ color: '#666666' }}>所属には環境依存文字を使用できません</p>
      <div className={masterClasses.errorMessage}>
        <UIError errors={errors} />
      </div>

      <div className={uikitClasses.root}>
        <PrimaryReadOnlyField label="メールアドレス" value={email} />
        <UITextField
          type="text"
          name="name"
          label="ユーザー名"
          value={values.name}
          error={errors.name}
          required
          handleChange={handleChange}
        />
        <UITextField
          type="text"
          name="belongingName"
          label="所属名"
          value={values.belongingName ? values.belongingName : ''}
          error={errors.belongingName}
          required
          handleChange={handleChange}
        />
      </div>

      <div className="module-spacer--medium" />

      <FormGroup row>
        <UIReturn title="戻る" />
        <div className="module-spacer--button" />
        <UISubmit title="確認" />
      </FormGroup>
    </form>
  );
};

export default Form;
